export enum Difficulties {
    TRIVIAL,
    EASY,
    MEDIUM,
    CHALLENGING,
    VERY_HARD,
    IMPOSSIBILE
}